var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppointmentIcon(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4.5A1.5 1.5 0 0113.5 6v4.5H7A1.5 1.5 0 015.5 9V4.5H12zm.5 1.5v3.5H7a.5.5 0 01-.5-.5V5.5H12a.5.5 0 01.5.5zM14 5.93l2.788-2.22a.5.5 0 01.812.39v6.526a.5.5 0 01-.812.392L14 8.796V5.93zm2.6 3.659L15 8.315V6.412l1.6-1.274V9.59z",
    fill: "#1C1C1C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.75 13a1 1 0 00.04.281c-.066.047-.128.1-.186.158L.896 15.146A.5.5 0 001.25 16h21.5a.5.5 0 00.312-.89l-2.226-1.781a1.509 1.509 0 00-.116-.085 1 1 0 00.03-.244V1a1 1 0 00-1-1h-16a1 1 0 00-1 1v12zm17-12h-16v12h16V1zm.15 13a.5.5 0 01.312.11l1.113.89H2.457l.854-.854A.5.5 0 013.664 14H19.9z",
    fill: "#1C1C1C"
  })));
}
export default SvgAppointmentIcon;